import React from "react";
function Button({ children, type = 'button', onClick, variant = 'primary' }) {
  const baseClasses =
    'px-4 py-2 min-w-[140px] rounded font-semibold focus:outline-none text-sm whitespace-nowrap';
  const variants = {
    primary: 'bg-orange-500 text-white hover:bg-orange-600',
    secondary: 'bg-gray-300 text-black hover:bg-gray-400',
  };
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]}`}
    >
      {children}
    </button>
  );
}

export default Button;


// function Button({children, type='button', onClick, variant='primary',}){
//     const baseClasses= 'px-4 py-2 min-w-[140px] rounded font-semibold focus:outline-none text-sm whitespace-nowrap';
//     const variants = {
//         primary: 'bg-orange-500 text-white hover:bg-orange-600',
//         secondary: 'bg-gray-300 text-black hover:bg-gray-400',
//     };
//     return (
//         <button
//             type={type}
//             onClick={onClick}
//             className={`${baseClasses} ${variants[variant]}`}
//         >
//             {children}
//         </button>


//     );
// }
// export default Button;